import { fetchGet } from './api';
import { ISchoolYear } from '../types/school-year.type';

export const fetchSchoolYears = () => fetchGet<ISchoolYear[]>('school-years');
